var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaintsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1955_57199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2188 2H3.78125C2.79919 2 2 2.82073 2 3.82927V16.0244C2 17.0329 2.79919 17.8537 3.78125 17.8537H5.5625V20.9024C5.5625 21.1268 5.68244 21.3341 5.876 21.4402C5.96387 21.489 6.06006 21.5122 6.15625 21.5122C6.27144 21.5122 6.38662 21.4781 6.48519 21.4098L11.6793 17.8537H19.2188C20.2008 17.8537 21 17.0329 21 16.0244V3.82927C21 2.82073 20.2008 2 19.2188 2ZM19.8125 16.0244C19.8125 16.361 19.5465 16.6341 19.2188 16.6341H11.5C11.3824 16.6341 11.2684 16.6695 11.1711 16.7366L6.75 19.7634V17.2439C6.75 16.9073 6.484 16.6341 6.15625 16.6341H3.78125C3.4535 16.6341 3.1875 16.361 3.1875 16.0244V3.82927C3.1875 3.49268 3.4535 3.21951 3.78125 3.21951H19.2188C19.5465 3.21951 19.8125 3.49268 19.8125 3.82927V16.0244ZM10.4075 6.45976C10.3576 6.04756 10.6699 5.68293 11.0749 5.68293H11.9263C12.3312 5.68293 12.6436 6.04756 12.5937 6.45976L12.1686 9.9561C12.127 10.3012 11.8408 10.561 11.5012 10.561C11.1616 10.561 10.8754 10.3012 10.8338 9.9561L10.4087 6.45976H10.4075ZM12.6875 12.9756C12.6875 13.6488 12.1555 14.1951 11.5 14.1951C10.8445 14.1951 10.3125 13.6488 10.3125 12.9756C10.3125 12.3024 10.8445 11.7561 11.5 11.7561C12.1555 11.7561 12.6875 12.3024 12.6875 12.9756Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1955_57199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19.5122,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintsIcon);
export default __webpack_public_path__ + "static/media/complaintsIcon.bc1d30dde22e7a89d377503f53f8d436.svg";
export { ForwardRef as ReactComponent };